import { IComponentOptions } from "angular";
import { ThreeRiversMachineTypeIdDetailViewComponentController } from "./controller";

export const vsComponentName = "threeRiversMachineTypeIdDetailViewComponent";

export const threeRiversMachineTypeIdDetailViewComponentOptions: IComponentOptions =
  {
    controller: ThreeRiversMachineTypeIdDetailViewComponentController,
    controllerAs: "threeRiversMachineTypeIdDetailViewComponentController",
    template: require("!html-loader!./index.html").default,
    bindings: {
      typeId: "<",
      progressiveCalculatedFields: "<?",
    },
  };
